"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var dateformat_1 = __importDefault(require("dateformat"));
var styled_components_1 = __importDefault(require("styled-components"));
var material_1 = require("@mui/material");
var digitransit_1 = require("../../../services/digitransit");
var DEFAULT_NUMBER_OF_DEPARTURES = 10;
var STOP_SCHEDULE_UPDATE_INTERVAL = 15 * 60 * 1000; // Milliseconds
var UPDATE_CLOCK_INTERVAL = 10 * 1000; // Milliseconds
var MetroIcon = function () { return (react_1.default.createElement("svg", { viewBox: '0 0 24 24', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink', style: {
        fill: 'rgb(202, 64, 0)',
        height: '16px',
        width: '16px',
        margin: '0px',
        position: 'relative',
        top: '2px'
    } },
    react_1.default.createElement("title", null, "icon-train"),
    react_1.default.createElement("g", { id: 'Desktop', stroke: 'none', strokeWidth: '1', fillRule: 'evenodd' },
        react_1.default.createElement("g", { id: 'icon-subway' },
            react_1.default.createElement("g", { id: 'icon_subway' },
                react_1.default.createElement("g", { id: 'Group-3' },
                    react_1.default.createElement("path", { d: 'M-8.45070423e-06,3.0096507 C-8.45070423e-06,1.39269296 1.34745634,0.045228169 2.96441408,0.045228169 L20.9304423,0.045228169 C22.6074,0.045228169 23.9547803,1.39269296 23.9547803,3.0096507 L23.9547803,20.9757634 C23.9547803,22.6525521 22.6074,24.0000169 20.9304423,24.0000169 L2.96441408,24.0000169 C1.34745634,24.0000169 -8.45070423e-06,22.6525521 -8.45070423e-06,20.9757634 L-8.45070423e-06,3.0096507 Z', id: 'Fill-1' })),
                react_1.default.createElement("path", { d: 'M17.2609854,9.10639685 L17.2609854,8.60241099 C17.2609854,8.57270569 17.3213118,8.54308408 17.381553,8.54308408 L17.381553,20.64 L21.12,20.64 L21.12,2.88 L15.6028191,2.88 L12.1356279,15.0066212 L12.0753867,15.8367796 L11.9849397,15.8367796 L11.8944927,15.0066212 L8.42738667,2.88 L2.88,2.88 L2.88,20.64 L6.67877334,20.64 L6.67877334,8.54308408 C6.70889397,8.54308408 6.76913523,8.57270569 6.76913523,8.60241099 L6.76913523,9.10639685 L10.1458794,20.64 L13.8542057,20.64 L17.2609854,9.10639685 Z', id: 'Fill-4', fill: '#FFFFFF' })))))); };
var renderDestinationText = function (destination) {
    var parts = destination.split('(M)');
    if (parts.length > 1) {
        return (react_1.default.createElement(react_1.Fragment, null, parts
            .filter(function (p) { return p.length > 2; })
            .map(function (part, i) { return (react_1.default.createElement("span", { key: "part-".concat(i) },
            part,
            " ",
            react_1.default.createElement(MetroIcon, null))); })));
    }
    return destination;
};
var CurrentDate = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 20px;\n  font-weight: 400;\n  background-color: #ffffff;\n  color: #0057a2;\n  border-radius: 0.2em;\n  padding: 4px;\n  text-align: center;\n  width: 60px;\n  float: right;\n"], ["\n  font-size: 20px;\n  font-weight: 400;\n  background-color: #ffffff;\n  color: #0057a2;\n  border-radius: 0.2em;\n  padding: 4px;\n  text-align: center;\n  width: 60px;\n  float: right;\n"])));
var useStyles = (0, makeStyles_1.default)(function () { return ({
    container: {
        height: '100%',
        overflow: 'hidden',
        fontWeight: '500'
    },
    containerPadding: {
        padding: '6px 6px 10px 6px'
    },
    tableHeader: {
        textAlign: 'left',
        lineHeight: 1.5
    },
    tableHeaderSub: {
        padding: '0px 6px 0px 6px',
        borderBottom: '3px solid #fff'
    },
    tableRow: {
        padding: '3px 6px 3px 6px'
    },
    tableRowDotted: {
        borderBottom: '3px dotted #fff'
    },
    titleContainer: {
        padding: '0px 6px 0px 6px'
    },
    title: {
        width: '450px',
        minHeight: '20px'
    }
}); });
var StopScheduleWidget = function (_a) {
    var stopProps = _a.stopProps, id = _a.id;
    var _b = (0, react_1.useState)([]), times = _b[0], setTimes = _b[1];
    var _c = (0, react_1.useState)(new Date()), currentDate = _c[0], setDate = _c[1];
    var classes = useStyles();
    // get stop times
    (0, react_1.useEffect)(function () {
        var numberOfDepartures = stopProps.numberOfDepartures || DEFAULT_NUMBER_OF_DEPARTURES;
        var getTimes = function () { return __awaiter(void 0, void 0, void 0, function () {
            var sortedStopTimes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, digitransit_1.getStopsTimes)(stopProps.stops, numberOfDepartures + 20, id)];
                    case 1:
                        sortedStopTimes = _a.sent();
                        setTimes(sortedStopTimes);
                        return [2 /*return*/];
                }
            });
        }); };
        getTimes();
        var timer = setInterval(function () {
            getTimes();
        }, STOP_SCHEDULE_UPDATE_INTERVAL);
        return function () {
            if (timer) {
                clearInterval(timer); // Return a funtion to clear the timer so that it will stop being called on unmount
            }
        };
    }, [stopProps.stops, stopProps.numberOfDepartures]);
    // update clock time
    (0, react_1.useEffect)(function () {
        var timeTimer = setInterval(function () {
            setDate(new Date());
        }, UPDATE_CLOCK_INTERVAL);
        return function () {
            if (timeTimer) {
                clearInterval(timeTimer);
            }
        };
    }, []);
    var backgroundColor = stopProps.backgroundColor, fontFamily = stopProps.fontFamily, title = stopProps.title, titleColor = stopProps.titleColor, titleFontSize = stopProps.titleFontSize, tableHeaderTextColor = stopProps.tableHeaderTextColor, tableHeaderBackgroundColor = stopProps.tableHeaderBackgroundColor, tableHeaderFontSize = stopProps.tableHeaderFontSize, bodyTextColor = stopProps.bodyTextColor, bodyFontSize = stopProps.bodyFontSize, showTime = stopProps.showTime, showStopNameColumn = stopProps.showStopNameColumn, useStopNameAsTitle = stopProps.useStopNameAsTitle, stops = stopProps.stops, numberOfDepartures = stopProps.numberOfDepartures, showVia = stopProps.showVia;
    var firstStopName = stops.length > 0 ? stops[0].name : '';
    var currentTime = Date.now();
    // show only upcoming stop times and filter out already passed times
    var nextTimes = times
        .filter(function (_a) {
        var realArrivalDate = _a.realArrivalDate;
        return realArrivalDate >= currentTime;
    })
        .slice(0, numberOfDepartures);
    return (react_1.default.createElement("div", { className: classes.container, style: {
            backgroundColor: backgroundColor || '#0057a2',
            fontFamily: fontFamily || 'Roboto',
            fontSize: bodyFontSize ? "".concat(bodyFontSize, "px") : '20px'
        } },
        react_1.default.createElement("div", { className: classes.containerPadding },
            (title || useStopNameAsTitle || showTime) && (react_1.default.createElement(material_1.Grid, { container: true, className: classes.titleContainer },
                react_1.default.createElement(material_1.Grid, { item: true, xs: 10, className: classes.title, style: {
                        color: titleColor || '#ffffff',
                        fontSize: titleFontSize ? "".concat(titleFontSize, "px") : '30px'
                    } }, useStopNameAsTitle ? firstStopName : title),
                react_1.default.createElement(material_1.Grid, { item: true, xs: 2 }, showTime && react_1.default.createElement(CurrentDate, null, (0, dateformat_1.default)(currentDate, 'HH:MM'))))),
            react_1.default.createElement(material_1.Grid, { container: true, className: classes.tableHeader, style: {
                    color: tableHeaderTextColor || '#ffffff',
                    backgroundColor: tableHeaderBackgroundColor || '#0057a2',
                    fontSize: tableHeaderFontSize ? "".concat(tableHeaderFontSize, "px") : '18px'
                } },
                react_1.default.createElement(material_1.Grid, { item: true, container: true, className: classes.tableHeaderSub },
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 2 }, "Linja"),
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 6 }, "M\u00E4\u00E4r\u00E4np\u00E4\u00E4"),
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 2 }, showStopNameColumn ? 'Lait./Pys.' : ''),
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 2, style: { textAlign: 'right' } }, "Aika/min"))),
            nextTimes && nextTimes.length > 0 && (react_1.default.createElement(material_1.Grid, { container: true }, nextTimes.map(function (time, i) {
                var _a;
                var trip = time.trip, headsign = time.headsign, errorMessage = time.errorMessage, realArrivalDate = time.realArrivalDate, platformCode = time.platformCode;
                var diffMin = (realArrivalDate - Date.now()) / 1000 / 60;
                var minutesString = diffMin >= 0 && diffMin <= 10 ? "".concat(Math.round(diffMin)) : undefined;
                var isError = !!errorMessage;
                return (react_1.default.createElement(material_1.Grid, { item: true, xs: 12, container: true, key: "row-".concat(i), className: (0, classnames_1.default)((_a = {},
                        _a[classes.tableRow] = true,
                        _a[classes.tableRowDotted] = i < nextTimes.length - 1,
                        _a)), style: {
                        color: bodyTextColor || '#ffffff'
                    } },
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 2 }, trip.route.shortName),
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 6 }, renderDestinationText(showVia ? headsign : trip.tripHeadsign)),
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 2 }, showStopNameColumn && platformCode ? platformCode : ''),
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 2, style: { color: isError ? 'red' : 'inherit', textAlign: 'right' } }, minutesString && errorMessage === undefined
                        ? minutesString
                        : errorMessage
                            ? errorMessage
                            : (0, dateformat_1.default)(realArrivalDate, 'HH:MM'))));
            }))))));
};
exports.default = StopScheduleWidget;
var templateObject_1;
//# sourceMappingURL=StopScheduleWidget.js.map